import React from 'react';
import { GraduationCap } from 'lucide-react';

const Logo = () => {
  return (
    <div className="flex items-center space-x-2">
      <GraduationCap className="h-8 w-8 text-indigo-400" />
      <span className="text-xl font-bold">AcademiaHub</span>
    </div>
  );
};

export default Logo;